import React from 'react';
import { PropsWithChildren } from 'react';
import { useWindowDimensions, View, Modal, Image } from 'react-native';
import CreateResponsiveStyle from '../utils/responsiveStyle';
import { GlobalVariables } from '../utils/globalVariables';
type SectionProps = PropsWithChildren<{
  visible: boolean
}>;

function ModalLoading({visible = false}: SectionProps): JSX.Element {
  const layout = useWindowDimensions();
  const stylesGeneral = GlobalVariables.class(layout);
  const styles = responsiveStyle(layout);
  return (
    <Modal
      animationType="fade"
      transparent={true}
      visible={visible}
    >
      <View style={[stylesGeneral('generalContainer'), styles('modal')]}>
        <View style={styles('loading')}>
          <Image style={styles('icon')} source={require('../source/image/loading2.gif')} resizeMode="cover" />
        </View>
      </View>
    </Modal>
  );
}
const responsiveStyle = CreateResponsiveStyle({
  modal:{
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#ffffffe3',
  },
  loading:{
    position: 'relative',
    width: 380,
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    height: 270,
    borderRadius: 15,
  },
  icon:{
    width: 310,
    height: 310,
  },
}, {
  loading:{
    width: '80%',
    height: 250,
  },
});
export default ModalLoading;
